import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setClipboardElementUuidReducer = (state: EditorState, action: PayloadAction<{ uuid: number | undefined }>) => {
  state.clipboardElementUuid = action.payload.uuid;
};

export default setClipboardElementUuidReducer;
